module.exports = __webpack_public_path__ + "img/empty-team.32cef912.svg";